/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

const ApiService = Shopware.Classes.ApiService;

class DvsnFormBuilderErrorHandlerService extends ApiService {
    handleApiError(vm, error, {title, message} = {}) {
        let str = '';

        if (error?.response?.data?.errors?.[0]?.detail) {
            str = '<br />' + error.response.data.errors[0].detail;
        }

        vm.createNotificationError({
            variant: 'error',
            title: title ?? vm.$t('global.default.error'),
            message: vm.$t(message) + '<br />' + error.toString() + str,
        });
    }
}

export default DvsnFormBuilderErrorHandlerService;
